import React from 'react';
import { shape, string } from 'prop-types';
import TableCell from '@material-ui/core/TableCell';

import WeatherDataContextMenu from './WeatherDataContextMenu';

const WeatherDataActionCell = ({ row, onToggleWeatherDataModal}) => (
    <TableCell key={row.id}>
        <WeatherDataContextMenu onToggleWeatherDataModal={onToggleWeatherDataModal} weatherData={row} />
    </TableCell>
);

WeatherDataActionCell.defaultProps = {
    row: {}
};

WeatherDataActionCell.propTypes = {
    row: shape({
        recalculationStatus: string
    })
};

export default WeatherDataActionCell;
